export default "__VITE_ASSET__J6SEVd7T__"